import { getStartAppParams } from "@shared/utils";
import { Loader } from "@widgets/Loader";
import { FC, ReactNode, useEffect, useState } from "react";
import { LOCAL_STORAGE, usePostApiReferralSystemMutation } from "..";

interface AuthProviderProps {
  children: ReactNode;
}

export const ReferralSystemProvider: FC<AuthProviderProps> = (props) => {
  const { children } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [sendReferral] = usePostApiReferralSystemMutation();

  const checkReferral = async () => {
    try {
      setIsLoading(true);

      const startAppParams = getStartAppParams();
      const targetUserId = localStorage.getItem(LOCAL_STORAGE.UserId);
      if (!startAppParams || !targetUserId) return;

      await sendReferral({
        code: startAppParams.code,
        target_user_id: targetUserId,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkReferral();
  }, []);

  if (isLoading) return <Loader />;
  return <>{children}</>;
};
